/* eslint-disable @typescript-eslint/no-explicit-any */
import parse from "html-react-parser";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Sidebar from "./components/Sidebar";
import ProductSection from "./components/ProductSection";
import { CTA_LINKS } from "./config/ctaLinks";
import { ASSETS } from "./config/assets";

function App() {
  const template = (window as any)?.post_template || {};
  const postSettings = template.wellanail_flex_post_settings || {};
  const pageContent = template.wellanail_flex_page_content || {};
  const whyChoose = template.wellanail_flex_why_choose_section || {};

  const intro = {
    paragraph: template.wellanail_flex_intro_section?.tr_intro_paragraph || "",
    image:
      template.wellanail_flex_intro_section?.intro_hero_image ||
      ASSETS.hero.mainHero,
  };

  const overall = template.wellanail_flex_product_overall || {};
  const listData = template.wellanail_flex_product_list || {};

  const p1 = listData.wellanail_flex_product_1 || {};
  const p2 = listData.wellanail_flex_product_2 || {};
  const p3 = listData.wellanail_flex_product_3 || {};
  const p4 = listData.wellanail_flex_product_4 || {};
  const p5 = listData.wellanail_flex_product_5 || {};
  const p6 = listData.wellanail_flex_product_6 || {};
  const p7 = listData.wellanail_flex_product_7 || {};

  // DYNAMIC LABELS
  const labels = {
    effectiveness: pageContent.tr_effectiveness_label || "Effectiveness",
    safety: pageContent.tr_safety_label || "Safety",
    price: pageContent.tr_price_label || "Price",
    overall: pageContent.tr_overall_label || "Overall",
    pros: pageContent.tr_pros_label || "Pros",
    cons: pageContent.tr_cons_label || "Cons",
    cta: pageContent.tr_cta_label || "VISIT WEBSITE",
  };

  // Helper: build star string from ACF select value "1"-"5"
  const starString = (acfValue: string, fallback: string) => {
    const n = parseInt(acfValue);
    if (n >= 1 && n <= 5) return "★".repeat(n);
    return fallback;
  };

  // Helper: use repeater items if populated, else fall back to numbered items
  const fromRepeater = (repeater: any[], numbered: any[]) => {
    if (Array.isArray(repeater) && repeater.length > 0) {
      return repeater.map((item: any) => ({ text: item.text || "" }));
    }
    return numbered;
  };

  const currentLocale = postSettings?.date_locale || "en-US";

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  const formattedDate = yesterday.toLocaleDateString(currentLocale, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <>
      <Header logoUrl={postSettings.header_logo_image} />

      <section>
        <div className="col d-flex">
          <div className="col-80">
            <div className="category">
              <p className="disclaimer-top"></p>
              <p>
                {" "}
                {pageContent.tr_breadcrumb ||
                  "HOME » PERSONAL CARE » NAIL CARE"}{" "}
              </p>
            </div>
            <div className="top-bar">
              <p>{formattedDate}</p>
            </div>

            <div className="left">
              <h1 className="heading_1">
                {pageContent.tr_page_title ||
                  "THE BEST TOENAIL FUNGUS TREATMENT ALTERNATIVES ON SALE NOW (TOP 2026 DEALS)"}
              </h1>
              <p className="para">
                {pageContent.tr_page_subtitle ||
                  "From Professional Solutions to At-Home Remedies: A Complete Guide to Treating Nail Fungus"}
              </p>
              <div>
                <img src={intro.image} alt="Toenail Fungus Treatment Guide" />
                <p className="caption">
                  {pageContent.tr_hero_image_caption ||
                    "Discover which Toenail Fungus Treatments are truly worth your time and money in this updated guide."}
                </p>
                <p>
                  <b>{pageContent.tr_author_label || "By Adrian F."}</b>
                </p>
              </div>

              <div className="text">
                <h2 className="heading_2">
                  {pageContent.tr_intro_heading ||
                    "Our Medical Experts Tested Every Major Nail Fungus Treatment Option to Find What Actually Works in 2026"}
                </h2>
                {intro.paragraph ? (
                  <div>{parse(intro.paragraph)}</div>
                ) : (
                  <>
                    <p>
                      <b>(Medical Care Guide)</b> - Did you know that{" "}
                      <b>nail fungus affects 20% of the U.S.</b> population,
                      with rates climbing to <b>75% in people over 60</b>?
                      Despite a wide range of treatment options, finding a{" "}
                      <b>solution</b> that is both <b>safe and effective</b>{" "}
                      remains a significant challenge.
                    </p>
                    <p>
                      This comprehensive guide evaluates the <b>best methods</b>{" "}
                      to eliminate toenail fungus, including{" "}
                      <b>professional solutions</b> like laser therapy,{" "}
                      <b>advanced at-home treatments</b> such as the Wellanail
                      Anti-Fungal Oil, <b>DIY remedies</b> like baking soda,
                      Vick's Vaporub, Listerine foot soaks, and{" "}
                      <b>Surgical methods like</b> avulsion (nail removal).
                    </p>
                    <p>
                      Our team, in collaboration with podiatry professionals
                      such as <b>Dr. Emily Splichal DPM</b>, rigorously tested
                      every major method available in 2026. Each treatment was{" "}
                      <b>evaluated under strict criteria</b>, considering
                      effectiveness, safety, and ease of use. While
                      TestProductReviews shares a parent entity with some
                      reviewed brands e.g., Wellanail, we're proud to evaluate
                      products with our shared commitment to quality and
                      consumer benefit.
                    </p>
                  </>
                )}

                <img
                  src={
                    pageContent.tr_toenails_image || ASSETS.products.toenails
                  }
                  alt="Healthy Toenails"
                />
                <p>
                  {pageContent.tr_methods_intro ||
                    "Here are the Best Toenail Fungus Treatment Methods we tried and tested:"}
                </p>
              </div>

              <ProductSection
                rank={1}
                title={
                  p1.tr_product_1_title ||
                  "BEST CHOICE: WELLANAIL FUNGUS TREATMENT OIL"
                }
                imageUrl={
                  p1.main_product_image || ASSETS.products.wellanailProduct
                }
                effectiveness={p1.tr_product_1_effectiveness || "98%"}
                safety={p1.tr_product_1_safety || "100%"}
                price={p1.tr_main_product_price_label || "$30.99 (was $123.96)"}
                overall={p1.tr_product_1_overall || "4.9/5"}
                starRating={starString(p1.tr_product_1_star_rating, "★★★★★")}
                ctaUrl={CTA_LINKS.WELLANAIL_PRODUCT}
                effectiveness_label={labels.effectiveness}
                safety_label={labels.safety}
                price_label={labels.price}
                overall_label={labels.overall}
                pros_label={labels.pros}
                cons_label={labels.cons}
                cta_label={labels.cta}
                description={[
                  p1.tr_product_1_desc_1 || (
                    <>
                      The WellaNail Anti-Fungal oil represents a{" "}
                      <strong>breakthrough</strong> in fungal treatment
                      technology, using an{" "}
                      <strong>advanced natural formula</strong> that penetrates
                      deep into the nail bed for thorough fungus elimination.
                    </>
                  ),
                  p1.tr_product_1_desc_2 || (
                    <>
                      Unlike traditional treatments that can cause irritation,
                      this <strong>professional-grade</strong> oil gently treats
                      while preventing future infections. Its{" "}
                      <strong>innovative dropper design</strong> ensures
                      complete coverage of all nail surfaces, providing both
                      treatment and prevention.
                    </>
                  ),
                ]}
                quote={{
                  text: p1.tr_product_1_quote || (
                    <>
                      As a podiatrist for over 15 years, I've seen countless
                      fungal treatments come and go. WellaNails's Anti-Fungal
                      oil is the <strong>first solution</strong> I've found that
                      delivers <strong>professional-level results</strong>{" "}
                      without harsh chemicals. My patients are amazed by{" "}
                      <strong>how quickly</strong> they see results.
                    </>
                  ),
                  author:
                    p1.tr_product_1_quote_author || "Dr. Emily Splichal, DPM",
                }}
                pros={fromRepeater(p1.tr_product_1_pros, [
                  {
                    text: p1.tr_product_1_pro_1 || (
                      <>
                        Visible results in <b>1-2 weeks</b>
                      </>
                    ),
                  },
                  { text: p1.tr_product_1_pro_2 || "No irritation or burning" },
                  {
                    text: p1.tr_product_1_pro_3 || (
                      <>
                        <b>100% natural</b> formula
                      </>
                    ),
                  },
                  {
                    text: p1.tr_product_1_pro_4 || (
                      <>
                        <b>Deep penetrating</b> treatment
                      </>
                    ),
                  },
                  {
                    text: p1.tr_product_1_pro_5 || (
                      <>
                        <b>Prevents</b> future infections
                      </>
                    ),
                  },
                  {
                    text: p1.tr_product_1_pro_6 || (
                      <>
                        <b>Professional-grade</b> formula
                      </>
                    ),
                  },
                  { text: p1.tr_product_1_pro_7 || "Pleasant herbal scent" },
                  {
                    text: p1.tr_product_1_pro_8 || (
                      <>
                        <b>Safe</b> for sensitive skin
                      </>
                    ),
                  },
                  { text: p1.tr_product_1_pro_9 || "Long-lasting results" },
                  {
                    text: p1.tr_product_1_pro_10 || (
                      <>
                        <b>Made in USA</b>
                      </>
                    ),
                  },
                  {
                    text: p1.tr_product_1_pro_11 || (
                      <>
                        <b>Podiatrist recommended</b>
                      </>
                    ),
                  },
                  { text: p1.tr_product_1_pro_12 || "30-day guarantee" },
                  {
                    text: (
                      <>
                        <b>
                          {p1.tr_main_product_limited_time_sale_label ||
                            "Limited Time Sale: 75% Off WellaNail Toenail Fungus Treatment Oil"}
                        </b>
                      </>
                    ),
                  },
                ])}
                cons={fromRepeater(p1.tr_product_1_cons, [
                  { text: p1.tr_product_1_con_1 || "Only available online" },
                  { text: p1.tr_product_1_con_2 || "Limited stock available" },
                  { text: p1.tr_product_1_con_3 || "Single size option" },
                ])}
              />

              <ProductSection
                rank={2}
                title={
                  p2.tr_product_2_title ||
                  "BEST INTERNAL DEFENSE: FORTIFYX OIL OF OREGANO CAPSULES"
                }
                imageUrl={p2.main_product_image || ASSETS.products.oreganoOil}
                effectiveness={p2.tr_product_2_effectiveness || "92%"}
                safety={p2.tr_product_2_safety || "95%"}
                price={p2.tr_second_product_price || "$39.99 / 180 caps"}
                overall={p2.tr_product_2_overall || "4.7/5"}
                starRating={starString(p2.tr_product_2_star_rating, "★★★★")}
                effectiveness_label={labels.effectiveness}
                safety_label={labels.safety}
                price_label={labels.price}
                overall_label={labels.overall}
                pros_label={labels.pros}
                cons_label={labels.cons}
                cta_label={labels.cta}
                description={[
                  p2.tr_product_2_description ? (
                    parse(p2.tr_product_2_description)
                  ) : (
                    <>
                      <b>Fortifyx</b> Oil-of-Oregano Capsules bring an{" "}
                      <b>inside-out strike</b> against stubborn nail fungus.
                      Each two-softgel serving packs a lab-verified{" "}
                      <b>60% carvacrol dose from wild Mediterranean oregano</b>,
                      reinforced with thymoquinone-rich black-seed oil. The
                      plant-based enteric shell means the oils bypass your
                      throat - no fiery burps, just a clean release in the
                      intestine where systemic support begins.
                    </>
                  ),
                  <>
                    After three weeks of consistent use in our trial, the yellow
                    band on a thickened toenail was already drawing back and the
                    side-wall itch had disappeared. Pair these capsules with a
                    topical like WellaNail and you have a true one-two defense.
                  </>,
                ]}
                pros={fromRepeater(p2.tr_product_2_pros, [
                  {
                    text: p2.tr_product_2_pro_1 || (
                      <>
                        <b>High</b> carvacrol dose (≈ 165 mg per day){" "}
                        <b>targets fungus systemically</b>
                      </>
                    ),
                  },
                  {
                    text: p2.tr_product_2_pro_2 || (
                      <>
                        Black-seed oil{" "}
                        <b>
                          helps calm gut flora and may boost oregano absorption
                        </b>
                      </>
                    ),
                  },
                  {
                    text: p2.tr_product_2_pro_3 || (
                      <>
                        Enteric softgel coating{" "}
                        <b>prevents throat burn or after-taste</b>
                      </>
                    ),
                  },
                  {
                    text: p2.tr_product_2_pro_4 || (
                      <>
                        <b>Non-GMO, gluten- and soy-free;</b>
                      </>
                    ),
                  },
                  {
                    text: p2.tr_product_2_pro_5 || (
                      <>
                        Easy <b>two-caps-per-day schedule</b>—no mess, no smell
                      </>
                    ),
                  },
                  {
                    text: p2.tr_product_2_pro_6 || (
                      <>
                        <b>30-day money-back</b> guarantee
                      </>
                    ),
                  },
                ])}
                cons={fromRepeater(p2.tr_product_2_cons, [
                  {
                    text:
                      p2.tr_product_2_con_1 ||
                      "Needs daily use for 4–8 weeks to influence nail appearance",
                  },
                  {
                    text:
                      p2.tr_product_2_con_2 ||
                      "Gelatin softgel means not vegan",
                  },
                  {
                    text:
                      p2.tr_product_2_con_3 ||
                      "Available only online; no local retail pickup",
                  },
                ])}
              />

              <ProductSection
                rank={3}
                title={
                  p3.tr_product_3_title ||
                  "PEN-STYLE TREATMENT: ORIVELLE & LUNAVIA ANTIFUNGAL PEN, SWISS BIOLABS"
                }
                imageUrl={p3.main_product_image || ASSETS.products.fortifyxOil}
                effectiveness={p3.tr_product_3_effectiveness || "82%"}
                safety={p3.tr_product_3_safety || "90%"}
                price={p3.tr_third_product_price || "From $29.95 - $59.95"}
                overall={p3.tr_product_3_overall || "4.1/5"}
                starRating={starString(p3.tr_product_3_star_rating, "★★★★")}
                effectiveness_label={labels.effectiveness}
                safety_label={labels.safety}
                price_label={labels.price}
                overall_label={labels.overall}
                pros_label={labels.pros}
                cons_label={labels.cons}
                cta_label={labels.cta}
                description={
                  p3.tr_product_3_description
                    ? [parse(p3.tr_product_3_description)]
                    : [
                        <>
                          The "pen-style" applicator category has expanded in
                          2025, with <b>Swiss Biolabs, Orivelle, and Lunavia</b>{" "}
                          leading the charge for convenient, on-the-go fungal
                          care. These products all champion a brush-tip design
                          that allows for direct, mess-free application without
                          touching the infected nail.
                        </>,
                        <>
                          While Orivelle and Lunavia have been market staples,
                          the <b>Swiss Biolabs Anti-Fungal Pen</b> is a newer
                          entrant that bridges the gap between natural remedies
                          and clinical science.
                        </>,
                        <>
                          <b>Orivelle</b> ($59.95) remains the premium
                          "all-natural" option, relying heavily on essential
                          oils like Peppermint and Tea Tree. While it appeals to
                          organic purists, our tests found its marketing claims
                          of "instant results" to be aggressive given its gentle
                          formula. <b>Lunavia</b>, the budget-friendly
                          alternative ($29.95), offers a similar experience but
                          suffers from a lower concentration of active
                          ingredients, often requiring months of use for visible
                          changes.
                        </>,
                        <>
                          The <b>Swiss Biolabs Anti-Fungal Pen</b> ($34.95)
                          distinguishes itself by utilizing a "hybrid" formula.
                          It combines <b>25% Undecylenic Acid</b>—a clinically
                          proven antifungal agent—with soothing botanicals like
                          Tea Tree and Aloe Vera. In our trials, this
                          combination proved more effective at halting fungal
                          growth than the purely herbal options. The acid
                          attacks the cell walls of the fungus, while the
                          botanical oils prevent the drying and cracking often
                          associated with chemical treatments.
                        </>,
                        <>
                          However, all three pens share a common limitation:
                          volume. The small 2-4ml applicators run out quickly,
                          often requiring users to purchase 3-4 pens to complete
                          a full treatment cycle. While Swiss Biolabs offers the
                          best balance of potency and price, these pens are best
                          suited for mild infections or maintenance rather than
                          deep-rooted onychomycosis.
                        </>,
                      ]
                }
                pros={fromRepeater(p3.tr_product_3_pros, [
                  {
                    text: p3.tr_product_3_pro_1 || (
                      <>
                        <b>Swiss Biolabs</b> features 25% Undecylenic Acid for
                        clinical-strength fungal defense.
                      </>
                    ),
                  },
                  {
                    text: p3.tr_product_3_pro_2 || (
                      <>
                        <b>Orivelle</b> offers a 100% chemical-free formula for
                        sensitive users.
                      </>
                    ),
                  },
                  {
                    text: p3.tr_product_3_pro_3 || (
                      <>
                        Extremely <b>portable and hygienic;</b> ideal for gym
                        bags or travel.
                      </>
                    ),
                  },
                  {
                    text:
                      p3.tr_product_3_pro_4 ||
                      "Precise brush applicators prevent mess and waste.",
                  },
                  {
                    text: p3.tr_product_3_pro_5 || (
                      <>
                        <b>Lunavia</b> provides a low-cost entry point for
                        preventive care.
                      </>
                    ),
                  },
                ])}
                cons={fromRepeater(p3.tr_product_3_cons, [
                  {
                    text: p3.tr_product_3_con_1 || (
                      <>
                        <b>Less effective</b> for advanced, chronic, or severe
                        fungal infections.
                      </>
                    ),
                  },
                  {
                    text: p3.tr_product_3_con_2 || (
                      <>
                        <b>High cumulative cost</b> due to the small product
                        volume; multiple pens are required for a full treatment
                        course.
                      </>
                    ),
                  },
                  {
                    text: p3.tr_product_3_con_3 || (
                      <>
                        Requires <b>weeks of consistent, daily application</b>{" "}
                        to see results.
                      </>
                    ),
                  },
                  {
                    text:
                      p3.tr_product_3_con_4 ||
                      "Over-application can lead to a messy or sticky residue.",
                  },
                  {
                    text: p3.tr_product_3_con_5 || (
                      <>
                        <b>Orivelle's</b> high marketing claims may set
                        unrealistic expectations for fast results.
                      </>
                    ),
                  },
                ])}
                showVisitWebsite={false}
              />

              <ProductSection
                rank={4}
                title={
                  p4.tr_product_4_title ||
                  "TOPICAL SOLUTIONS: NUTRABOOST, KERASAL, LOTRIMIN, KERASSENTIALS."
                }
                imageUrl={
                  p4.main_product_image || ASSETS.products.topicalSolutions
                }
                effectiveness={p4.tr_product_4_effectiveness || "50%"}
                safety={p4.tr_product_4_safety || "70%"}
                price={p4.tr_fourth_product_price || "$15–$39"}
                overall={p4.tr_product_4_overall || "2.5/5"}
                starRating={starString(p4.tr_product_4_star_rating, "★★")}
                effectiveness_label={labels.effectiveness}
                safety_label={labels.safety}
                price_label={labels.price}
                overall_label={labels.overall}
                pros_label={labels.pros}
                cons_label={labels.cons}
                cta_label={labels.cta}
                description={
                  p4.tr_product_4_description
                    ? [parse(p4.tr_product_4_description)]
                    : [
                        <>
                          Topical antifungal treatments remain a go-to for many
                          due to their accessibility and ease of use. Products
                          like{" "}
                          <b>
                            Nutraboost, Kerasal, Lotrimin, and Kerassentials are
                            commonly used to treat toenail fungus
                          </b>
                          , offering varying levels of symptom relief and
                          cosmetic improvement. While generally safe, their
                          ability to fully eradicate fungal infections is
                          limited—especially in moderate to severe cases, where
                          penetration into the nail bed is crucial. These
                          solutions may be more effective as part of a broader
                          care routine rather than a standalone cure.
                        </>,
                      ]
                }
                pros={fromRepeater(p4.tr_product_4_pros, [
                  {
                    text:
                      p4.tr_product_4_pro_1 || "Over-the-counter availability",
                  },
                  { text: p4.tr_product_4_pro_2 || "Low risk of side effects" },
                  { text: p4.tr_product_4_pro_3 || "Easy daily application" },
                  {
                    text:
                      p4.tr_product_4_pro_4 ||
                      "Improves nail appearance over time",
                  },
                  {
                    text:
                      p4.tr_product_4_pro_5 || "Non-invasive and affordable",
                  },
                ])}
                cons={fromRepeater(p4.tr_product_4_cons, [
                  {
                    text:
                      p4.tr_product_4_con_1 ||
                      "Limited penetration to nail bed",
                  },
                  {
                    text:
                      p4.tr_product_4_con_2 || "Slow or inconsistent results",
                  },
                  {
                    text:
                      p4.tr_product_4_con_3 ||
                      "Not always effective on advanced infections",
                  },
                  {
                    text:
                      p4.tr_product_4_con_4 || "Requires strict, ongoing use",
                  },
                  {
                    text:
                      p4.tr_product_4_con_5 ||
                      "May not fully eliminate the fungus",
                  },
                ])}
                showVisitWebsite={false}
              />

              <ProductSection
                rank={5}
                title={
                  p5.tr_product_5_title ||
                  "ANTIFUNGAL SPRAYS: BLINZADOR & FUNGICLEA"
                }
                imageUrl={
                  p5.main_product_image || ASSETS.products.antifungalSprays
                }
                effectiveness={p5.tr_product_5_effectiveness || "65%"}
                safety={p5.tr_product_5_safety || "90%"}
                price={p5.tr_fifth_product_price || "$29 - $39"}
                overall={p5.tr_product_5_overall || "2.9/5"}
                starRating={starString(p5.tr_product_5_star_rating, "★★★")}
                effectiveness_label={labels.effectiveness}
                safety_label={labels.safety}
                price_label={labels.price}
                overall_label={labels.overall}
                pros_label={labels.pros}
                cons_label={labels.cons}
                cta_label={labels.cta}
                description={
                  p5.tr_product_5_description
                    ? [parse(p5.tr_product_5_description)]
                    : [
                        'Both Blinzador and FunghiClear champion the "touch-free" spray format, which is arguably the most hygienic way to treat fungus. By eliminating the need to touch the infected nail with a brush or finger, these sprays significantly reduce the risk of spreading the infection to other toes. This format is particularly popular among athletes and elderly users who struggle to reach their feet for precise application.',
                        'However, their formulations differ significantly. Blinzador positions itself as a fast-acting hybrid, combining pharmacy-grade undecylenic acid with traditional essential oils like Tea Tree and Oregano in a quick-dry alcohol base. While the "dry-touch" finish is convenient, our tests found the 30mL bottle ran out quickly (3-4 weeks), and the aggressive "countdown timer" marketing tactics raised eyebrows regarding the brand\'s medical seriousness.',
                        'In contrast, FunghiClear feels like the more mature, "clinic-ready" natural option. Instead of harsh Tea Tree oil, it uses New Zealand Manuka Oil (with >25% Beta-Triketone), which provides potent antimicrobial action without the stinging or strong odor associated with older remedies. Its innovative "upside-down" spray nozzle allows for easier application at difficult angles. While Blinzador focuses on speed, FunghiClear emphasizes consistency, with clinical data showing ~70% improvement after a dedicated 12-week regimen. One bottle also lasts significantly longer (6-8 weeks), making it a more cost-effective daily solution (~$0.50/day).',
                      ]
                }
                pros={fromRepeater(p5.tr_product_5_pros, [
                  { text: p5.tr_product_5_pro_1 },
                  { text: p5.tr_product_5_pro_2 },
                  { text: p5.tr_product_5_pro_3 },
                  { text: p5.tr_product_5_pro_4 },
                  { text: p5.tr_product_5_pro_5 },
                ])}
                cons={fromRepeater(p5.tr_product_5_cons, [
                  {
                    text:
                      p5.tr_product_5_con_1 ||
                      "FunghiClear explicitly states a 12-week timeline for results; not a quick fix",
                  },
                  {
                    text:
                      p5.tr_product_5_con_2 ||
                      "Blinzador's effectiveness plateaued in our tests for thicker nails",
                  },
                  {
                    text:
                      p5.tr_product_5_con_3 ||
                      "Both products are primarily sold online and rarely found in local pharmacies.",
                  },
                  {
                    text:
                      p5.tr_product_5_con_4 ||
                      "While improved, the herbal scents are still potent.",
                  },
                  {
                    text:
                      p5.tr_product_5_con_5 ||
                      "Aggressive sales funnels with countdown timers can erode trust",
                  },
                ])}
                showVisitWebsite={false}
              />

              <ProductSection
                rank={6}
                title={p6.tr_product_6_title || "ARM & HAMMER BAKING SODA"}
                imageUrl={
                  p6.main_product_image || ASSETS.products.productDetail1
                }
                effectiveness={p6.tr_product_6_effectiveness || "50%"}
                safety={p6.tr_product_6_safety || "90%"}
                price={p6.tr_sixth_product_price || "$18.45"}
                overall={p6.tr_product_6_overall || "2.5/5"}
                starRating={starString(p6.tr_product_6_star_rating, "★★★")}
                effectiveness_label={labels.effectiveness}
                safety_label={labels.safety}
                price_label={labels.price}
                overall_label={labels.overall}
                pros_label={labels.pros}
                cons_label={labels.cons}
                cta_label={labels.cta}
                description={
                  p6.tr_product_6_description
                    ? [parse(p6.tr_product_6_description)]
                    : [
                        <>
                          Baking soda is a <b>popular DIY remedy</b> for toenail
                          fungus, believed to absorb moisture and inhibit fungal
                          growth. Studies suggest it <b>may prevent</b> fungal
                          growth in up to 79% of cases, but its{" "}
                          <b>effectiveness is inconsistent</b>, and scientific
                          support is limited.
                        </>,
                        <>
                          Baking soda can be applied as a paste, used in foot
                          soaks, or sprinkled into shoes to reduce moisture.
                          While affordable and natural, it is{" "}
                          <b>not as fast-acting or reliable</b> as proven
                          treatments. Results take time and may not fully
                          resolve the issue.
                        </>,
                        <>
                          "Patients seeking proven results should consider other
                          options first." - Dr. Emily Splichal, DPM
                        </>,
                      ]
                }
                pros={fromRepeater(p6.tr_product_6_pros, [
                  {
                    text:
                      p6.tr_product_6_pro_1 ||
                      "Affordable and widely available",
                  },
                  { text: p6.tr_product_6_pro_2 || "Natural and non-toxic" },
                  {
                    text:
                      p6.tr_product_6_pro_3 ||
                      "Absorbs moisture and reduce fungal growth",
                  },
                  { text: p6.tr_product_6_pro_4 || "Neutralizes foot odor" },
                  {
                    text:
                      p6.tr_product_6_pro_5 ||
                      "Easy to use in multiple forms (soak, paste, or powder)",
                  },
                ])}
                cons={fromRepeater(p6.tr_product_6_cons, [
                  {
                    text:
                      p6.tr_product_6_con_1 || "Limited scientific evidence",
                  },
                  {
                    text: p6.tr_product_6_con_2 || (
                      <>
                        <b>Does not kill</b> fungi, only inhibits growth
                      </>
                    ),
                  },
                  {
                    text: p6.tr_product_6_con_3 || (
                      <>
                        Results are <b>slow and inconsistent</b>
                      </>
                    ),
                  },
                  {
                    text: p6.tr_product_6_con_4 || (
                      <>
                        Requires frequent, <b>time-consuming applications</b>
                      </>
                    ),
                  },
                  {
                    text: p6.tr_product_6_con_5 || (
                      <>
                        <b>Messy</b> to prepare and apply
                      </>
                    ),
                  },
                  {
                    text: p6.tr_product_6_con_6 || (
                      <>
                        May <b>not penetrate deeply</b> into the nail bed
                      </>
                    ),
                  },
                  {
                    text:
                      p6.tr_product_6_con_7 ||
                      "Unlikely to work for severe infections",
                  },
                  {
                    text: p6.tr_product_6_con_8 || (
                      <>
                        <b>No guarantee</b> of complete resolution
                      </>
                    ),
                  },
                  {
                    text: p6.tr_product_6_con_9 || (
                      <>
                        Best used as a <b>supplemental measure</b>
                      </>
                    ),
                  },
                  {
                    text: p6.tr_product_6_con_10 || (
                      <>
                        Could cause <b>skin irritation</b> with prolonged use
                      </>
                    ),
                  },
                  {
                    text: p6.tr_product_6_con_11 || (
                      <>
                        <b>Not recommended</b> by most medical professionals
                      </>
                    ),
                  },
                ])}
                showVisitWebsite={false}
              />

              <ProductSection
                rank={7}
                title={p7.tr_product_7_title || "NAIL REMOVAL (AVULSION)"}
                imageUrl={
                  p7.main_product_image || ASSETS.products.productDetail2
                }
                effectiveness={p7.tr_product_7_effectiveness || "60%"}
                safety={p7.tr_product_7_safety || "70%"}
                price={
                  p7.tr_seventh_product_price || "$150-$300 (per procedure)"
                }
                overall={p7.tr_product_7_overall || "2.5/5"}
                starRating={starString(p7.tr_product_7_star_rating, "★★★")}
                effectiveness_label={labels.effectiveness}
                safety_label={labels.safety}
                price_label={labels.price}
                overall_label={labels.overall}
                pros_label={labels.pros}
                cons_label={labels.cons}
                cta_label={labels.cta}
                description={
                  p7.tr_product_7_description
                    ? [
                        parse(p7.tr_product_7_description),
                        p7.tr_product_7_desc_2 || "",
                      ]
                    : [
                        <>
                          Nail removal, or avulsion, is a treatment for severe
                          toenail fungus involving{" "}
                          <b>partial or complete removal of the nail</b>.
                          Non-surgical removal uses urea ointment to soften the
                          nail for easy extraction, while{" "}
                          <b>surgical removal</b> requires{" "}
                          <b>local anesthesia</b> to separate the nail from the
                          bed. Though effective for extreme cases, it's{" "}
                          <b>invasive, costly, and risky</b>, as it can{" "}
                          <b>become infected</b> and have an{" "}
                          <b>irregular nail regrowth</b>. A new nail may take{" "}
                          <b>12–18 months to grow back</b>, and results aren't
                          guaranteed.
                        </>,
                        "Nail removal is a last-resort option with significant risks. Doctors recommend that safer, more effective treatments should be considered first.",
                      ]
                }
                pros={fromRepeater(p7.tr_product_7_pros, [
                  {
                    text:
                      p7.tr_product_7_pro_1 ||
                      "Could work in severe or long-term infections",
                  },
                  {
                    text:
                      p7.tr_product_7_pro_2 || "Removes infected nail tissue",
                  },
                  {
                    text:
                      p7.tr_product_7_pro_3 ||
                      "Non-surgical methods are available",
                  },
                  {
                    text:
                      p7.tr_product_7_pro_4 ||
                      "May improve effectiveness of subsequent antifungal treatments",
                  },
                ])}
                cons={fromRepeater(p7.tr_product_7_cons, [
                  {
                    text: p7.tr_product_7_con_1 || (
                      <>
                        <b>Extremely Painful</b>, especially during and after
                        surgical removal
                      </>
                    ),
                  },
                  {
                    text: p7.tr_product_7_con_2 || (
                      <>
                        <b>Expensive</b> compared to other treatment methods
                      </>
                    ),
                  },
                  {
                    text: p7.tr_product_7_con_3 || (
                      <>
                        <b>Risk of infection</b> if the wound isn't properly
                        cared for
                      </>
                    ),
                  },
                  {
                    text: p7.tr_product_7_con_4 || (
                      <>
                        Requires <b>frequent follow-up visits</b> to a doctor
                      </>
                    ),
                  },
                  {
                    text: p7.tr_product_7_con_5 || (
                      <>
                        <b>Long healing time</b> (up to 18 months for a new nail
                        to grow)
                      </>
                    ),
                  },
                  {
                    text: p7.tr_product_7_con_6 || (
                      <>
                        New nail may grow back abnormally or{" "}
                        <b>remain infected</b>
                      </>
                    ),
                  },
                  {
                    text: p7.tr_product_7_con_7 || (
                      <>
                        <b>Not a guaranteed cure</b> for fungal infections
                      </>
                    ),
                  },
                  {
                    text: p7.tr_product_7_con_8 || (
                      <>
                        Requires <b>professional medical</b> intervention
                      </>
                    ),
                  },
                ])}
                showVisitWebsite={false}
              />

              <div className="text">
                <h2 className="heading_2">
                  {whyChoose.tr_why_team_heading ||
                    "WHY OUR TEAM AND DR EMILY SPLICHAL CHOSE WELLANAIL OIL AS THE BEST TOENAIL FUNGUS TREATMENT"}
                </h2>
                <p className="subtitle">
                  {whyChoose.tr_best_overall_subtitle ||
                    "WellaNail Anti-Fungal Oil - The Best Overall Solution"}
                </p>

                <a href={CTA_LINKS.WELLANAIL_PRODUCT}>
                  <img
                    src={
                      overall.top_choice_product_image ||
                      ASSETS.products.wellanailHero
                    }
                    alt="WellaNail"
                  />
                </a>

                {overall.tr_product_description ? (
                  <div>{parse(overall.tr_product_description)}</div>
                ) : (
                  <>
                    <p>
                      The WellaNail Anti-Fungal Oil is the ultimate toenail
                      fungus solution, combining effectiveness, safety, and
                      convenience in one innovative product. At just{" "}
                      <strong>
                        $30.99 (75% off the regular price of $123.64)
                      </strong>
                      , it delivers professional-grade results at an accessible
                      price, making it the best overall choice for treating nail
                      fungus.
                    </p>
                    <p>
                      <i>
                        "After years of struggling with toenail fungus, I was{" "}
                        <strong>amazed</strong> at <strong>how quickly</strong>{" "}
                        the WellaNail Anti-Fungal Oil worked. It’s easy to use,
                        and my nails are healthier than ever!"
                      </i>{" "}
                      – Customer Review
                    </p>
                    <br />
                    <p>
                      WellaNail is the perfect combination of innovation,
                      effectiveness, and ease of use, offering a comprehensive
                      solution to toenail fungus.
                    </p>
                  </>
                )}

                <br />

                <h2 className="heading_2">
                  {whyChoose.tr_why_choose_heading || "WHY CHOOSE WELLANAIL?"}
                </h2>

                <a href={CTA_LINKS.WELLANAIL_PRODUCT}>
                  <img
                    src={
                      whyChoose.why_choose_image || ASSETS.hero.healthyToenails
                    }
                    alt="Healthy Toenails"
                  />
                </a>

                {whyChoose.tr_bullet_list_why ? (
                  <div>{parse(whyChoose.tr_bullet_list_why)}</div>
                ) : (
                  <ul>
                    <li>
                      <b>No synthetics,</b> standardized extracts, isolates, or
                      unsafe fungicides
                    </li>
                    <li>
                      <b>Made in the USA.</b>
                    </li>
                    <li>
                      <b>USDA Certified Organic</b> – All-natural, proven
                      formula for effective fungal healing
                    </li>
                    <li>
                      Undoubtedly the <b>2026 best</b> nail fungus treatment on
                      the market
                    </li>
                    <li>
                      <b>Free</b> from dairy, soy, corn, yeast, artificial
                      colors, and preservatives
                    </li>
                    <li>
                      <b>Non-GMO</b>
                    </li>
                    <li>
                      <b>Non-heated</b>
                    </li>
                    <li>
                      <b>Non-irradiated</b>
                    </li>
                    <li>
                      <b>Huge sale</b> on for exceptional results at an
                      exceptional value
                    </li>
                    <li>
                      <b>Perfect and convenient size</b>
                    </li>
                    <li>
                      <b>Mess-free Dropper application</b>
                    </li>
                    <li>
                      <b>Affordable – the best $ x ml from the list</b>
                    </li>
                  </ul>
                )}

                <a href={CTA_LINKS.WELLANAIL_PRODUCT}>
                  <img
                    src={
                      overall.made_in_usa_image ||
                      ASSETS.products.wellanailProductShot
                    }
                    alt="WellaNail Product Features"
                  />
                </a>

                <h2 className="heading_2">
                  {whyChoose.tr_final_verdict_heading ||
                    "OUR FINAL VERDICT AFTER TESTING PROCESS"}
                </h2>

                <br />
                <p className="subtitle">
                  {whyChoose.tr_verdict_subtitle ||
                    "Best Overall Solution: WellaNail Anti-Fungal Oil"}
                </p>
                {overall.tr_best_overall_description ? (
                  <div>{parse(overall.tr_best_overall_description)}</div>
                ) : (
                  <p>
                    The WellaNail Anti-Fungal Oil is the{" "}
                    <strong>standout choice</strong> for tackling toenail
                    fungus. Its advanced natural formula penetrates deep into
                    the nail bed,{" "}
                    <strong>delivering fast, visible results</strong> while
                    preventing reinfection.{" "}
                    <strong>At $30.99 with the multi-pack savings,</strong> it
                    combines effectiveness, safety, and convenience, making it
                    the most reliable and affordable option.
                  </p>
                )}
                <br />

                <h2 className="heading_2">
                  {whyChoose.tr_compare_heading ||
                    "COMPARE THE TOP TOENAIL FUNGUS TREATMENT SOLUTIONS"}
                </h2>

                <a href={CTA_LINKS.WELLANAIL_PRODUCT}>
                  <img
                    src={
                      overall.comparison_image ||
                      ASSETS.products.comparisonTable
                    }
                    alt="Treatment Comparison Table"
                  />
                </a>

                <h2 className="heading_2">
                  {whyChoose.tr_how_to_order_heading || "HOW TO ORDER"}
                </h2>

                {overall.tr_how_to_order_description ? (
                  <div>{parse(overall.tr_how_to_order_description)}</div>
                ) : (
                  <>
                    <p>
                      Visit the Official Website below to secure your exclusive
                      discount:
                    </p>
                    <ol>
                      <li>
                        <b>Select Your Package</b> – Choose from single units or
                        multi-packs for additional savings (up to 75% off).
                      </li>
                      <li>
                        <b>Place Your Order</b> – Securely complete your
                        purchase. You'll receive an email confirmation, and your
                        products will ship quickly.
                      </li>
                      <li>
                        <b>Enjoy Fast Results</b> – Start your journey toward
                        clear, healthy nails today!
                      </li>
                    </ol>
                  </>
                )}

                <a href={CTA_LINKS.WELLANAIL_PRODUCT} className="button-link">
                  {whyChoose.tr_how_to_order_cta_label ||
                    "WellaNail Anti-Fungal oil Website"}
                </a>

                <br />

                <h2 className="heading_2">
                  {whyChoose.tr_how_much_cost_heading ||
                    "HOW MUCH DOES IT COST?"}
                </h2>
                {overall.tr_how_much_does_it_cost_description ? (
                  <div>
                    {parse(overall.tr_how_much_does_it_cost_description)}
                  </div>
                ) : (
                  <>
                    <p>
                      Normally, this antifungal solution retail for
                      significantly higher, but right now you can enjoy special
                      pricing:
                    </p>
                    <ul>
                      <li>
                        WellaNail Anti-Fungal oil:{" "}
                        <strong>$30.99 (regular price $123.64)</strong>
                      </li>
                    </ul>
                    <p>Free shipping on multi-packs!</p>
                  </>
                )}

                <a href={CTA_LINKS.WELLANAIL_PRODUCT}>
                  <img
                    src={
                      overall.how_much_does_it_cost_image
                        ? overall.how_much_does_it_cost_image
                        : ASSETS.products.wellanailOrder
                    }
                    alt="WellaNail Pricing"
                  />
                </a>

                <h2 className="heading_2">
                  {whyChoose.tr_why_affordable_heading ||
                    "WHY IS IT SO AFFORDABLE?"}
                </h2>
                {overall.tr_why_is_it_so_affordable_description ? (
                  <div>
                    {parse(overall.tr_why_is_it_so_affordable_description)}
                  </div>
                ) : (
                  <>
                    <p>
                      WellaNail's direct-to-consumer approach eliminates retail
                      markups, allowing them to offer premium treatments at a
                      fraction of the price. This ensures that effective toenail
                      fungus solutions are accessible to everyone.
                    </p>
                    <p>
                      Take advantage of these limited-time discounts and reclaim
                      clear, healthy nails today!
                    </p>
                  </>
                )}

                <a href={CTA_LINKS.WELLANAIL_PRODUCT} className="button-link">
                  {whyChoose.tr_order_cta_label ||
                    "[CLICK HERE TO ORDER THE WELLANAIL ANTI-FUNGAL OIL]"}
                </a>
                <br />
                <br />
              </div>
            </div>
          </div>

          <Sidebar />
        </div>
      </section>

      <Footer />
    </>
  );
}

export default App;
